import React, { useCallback, useState } from 'react'
// import HandyBankLogo from 'custom/assets/logo/LOGO-SMALL.png'
import SettingsLogo from 'custom/assets/common-icons/settings.svg'
import NotificationLogo from 'custom/assets/common-icons/notification.svg'
import '../../styles/Header.css'
import { useHistory, useLocation } from 'react-router-dom'
import { useModal } from 'react-modal-hook'
import AuthService from '../../services/auth.service'
import { clearStore } from '../../utils/auth.service'
import { toast } from 'react-toastify'
import MediumModal from '../../components/Modal/MediumModel'
import { Container } from 'react-bootstrap'
import NeoButton from '../../components/NeoButton/NeoButton'
import { BANNER_KEYS, CLIENT_NAME, HEADER_SUBTITLE, LANDING_KEYS } from '../../utils/translation-constants'
import LogOutLogo from 'custom/assets/common-icons/Logout.svg'
import 'custom/styles/color_variable.css'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { profileSelector, profileImageSelector } from '../../selectors'
import UserImage from 'custom/assets/dashboard/dummy-user.png'
import { setAppLanguage } from '../../actions/app.actions'
import i18next from 'i18next'

export default function HeaderNew() {
  const history = useHistory()
  const dispatch = useDispatch()
  const location = useLocation()
  const { t } = useTranslation()
  const profile = useSelector(profileSelector)
  const image = useSelector(profileImageSelector)
  const [showModal, hideModal] = useModal(
    () => (
      <MediumModal bgBlur={true}>
        <div className='row' style={{ width: 385 }}>
          <div className='col-2'>
            <img src={LogOutLogo} style={{ marginTop: 20 }} />
          </div>

          <div className='col-10'>
            <div className='my-4'>
              <h6 className='font-weight-bolder log-out-text' style={{ fontStyle: 18 }}>
                {t(BANNER_KEYS.LOGOUT_CONFIRM_MESSAGE)}
              </h6>
            </div>
            <div className='row'>
              <div className='col-6'>
                <NeoButton
                  tabIndex='1'
                  mode='newDesign'
                  text={t(BANNER_KEYS.YES)}
                  type='button'
                  onClick={async () => {
                    try {
                      const response = await AuthService.logoutUser()
                      toast(response.message)
                      dispatch({ type: 'USER_LOGOUT' })
                      dispatch(setAppLanguage('EN'))
                      i18next.changeLanguage('EN')
                    } catch (err) {
                      toast(t(BANNER_KEYS.LOGOUT_SUCCESS))
                      dispatch({ type: 'USER_LOGOUT' })
                      dispatch(setAppLanguage('EN'))
                      i18next.changeLanguage('EN')
                    }
                  }}
                />
              </div>
              <div className='col-6'>
                <div
                  tabIndex={'2'}
                  style={{ textAlign: 'left', marginTop: 10 }}
                  className='back-cancel-style'
                  onClick={hideModal}>
                  {t(BANNER_KEYS.CANCEL)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </MediumModal>
    ),
    [],
  )

  const handleLogout = useCallback(async () => {
    showModal()
  }, [])

  return (
    <>
      <div className='header-new-section'>
        <Container style={{ height: 'inherit', border: 'none', borderColor: 'white' }}>
          <div
            className='d-flex'
            style={{ justifyContent: 'space-between', alignItems: 'center', height: 'inherit' }}>
            <div
              className='row'
              style={{
                backgroundColor: 'white',
                height: '75px',
                width: '412px',
                transform: 'skew(144deg)',
              }}>
              <div className='col-sm-4 logo-section'></div>
              <div
                className='col-sm-8 logo-title'
                style={{ marginTop: '21px', transform: 'skew(36deg)' }}>
                <h6>{t(CLIENT_NAME.CLIENT_HEADER_LABEL)}</h6>
                <span className='sub-header-new-section'>
                  {t(HEADER_SUBTITLE.HEADER_BANK_SLOGAN)}
                </span>
              </div>
            </div>
            <div className='d-flex'>
              <img
                style={{ marginRight: 30 }}
                onClick={() => history.push('/notifications')}
                src={NotificationLogo}
              />
              <div id='dropdown' style={{ position: 'relative' }}>
                {location.pathname === '/dashboard' && (
                  <>
                    <img src={SettingsLogo} />
                    <div className='dropdown-content' style={{ top: '36px' }}>
                      <div onClick={() => history.push('/profile')}>{t(BANNER_KEYS.PROFILE)}</div>
                      <div onClick={() => history.push('/change-password')}>
                        {t(BANNER_KEYS.CHANGE_PASSWORD)}
                      </div>
                      <div onClick={() => handleLogout()}>{t(BANNER_KEYS.LOGOUT)}</div>
                    </div>
                  </>
                )}
                {location.pathname !== '/dashboard' && (
                  <>
                    <div className='d-flex'>
                      <div
                        className='font-weight-600 text-light pr-2'
                        style={{ fontSize: '13px', marginTop: '7px' }}>
                        {t(LANDING_KEYS.HI)}, {profile?.firstName} {profile?.lastName}
                      </div>
                      <div className='pr-2'>
                        {image !== null && (
                          <img
                            src={`data:image/png;base64, ${image && (image.imageData || image)}`}
                            alt='user image'
                            height='35'
                            width='35'
                            style={{ borderRadius: '10px' }}
                          />
                        )}
                        {image === null && (
                          <img
                            src={UserImage}
                            alt='user image'
                            height='35'
                            width='35'
                            style={{ borderRadius: '10px' }}
                          />
                        )}
                      </div>
                    </div>
                    <div className='dropdown-content' style={{ left: '125px' }}>
                      <div onClick={() => history.push('/profile')}>{t(BANNER_KEYS.PROFILE)}</div>
                      <div onClick={() => history.push('/change-password')}>
                        {t(BANNER_KEYS.CHANGE_PASSWORD)}
                      </div>
                      <div onClick={() => handleLogout()}>{t(BANNER_KEYS.LOGOUT)}</div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  )
}
